import * as React from 'react';

interface OwnProps {
    detailsUrl: string;
    isLikedByMe: boolean;
    otherLikesCount: number;
}

/**
 * TODO: Resolve FAKE context
 * TODO: Use one XHR library - currently this is using jQuery because mk/xhr needs context.apiAuth (because first TODO)
 */
export const LikeSection: React.StatelessComponent<OwnProps> = ({ isLikedByMe, otherLikesCount, detailsUrl }) => {
    const count = Number(isLikedByMe) + otherLikesCount;

    if (!count) {
        return null;
    }

    return (
        <span
            className="like-section like-info-box"
            data-details-url={detailsUrl}
        >
            <span className="bullet">&nbsp;&nbsp;&bull;&nbsp;</span>
            <button className="as_link like-info-button">
                <span className="like-count">{count}</span>
                &nbsp;
                <i className="fa fa-thumbs-o-up" />
            </button>
        </span>
    );
};
